export const reloadLayoutSvc = (cy: any, layout: string) => {
  if (cy) cy.layout({ name: layout }).run();
};
